<template>
	<div id="web" v-if="webinfo">
		<div v-for="(item,index) in webinfo.floatSpecialList">
			<float :url="item.url" :imgurl="hoturl+item.img"></float>
		</div>
		<headinfo></headinfo>
		<!--工作动态-->
		<div class="gzdt container">
			<div class="gzdt-left">
				<ul>
					<li>
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<el-carousel indicator-position="none" direction="horizontal" trigger="click" height="343px">
									<el-carousel-item v-for="(item,index) in webinfo.newsList" :key="index">
										<router-link target="_blank" :to="{name:'details',params:{type:'news',id:item.id}}">
										<img :src="hoturl+item.img" width="532px" height="343px" />
										<p>
										<span style="
										  white-space: nowrap;
										  display: block;
										  width: 83%;
										  overflow: hidden;
										  text-overflow: ellipsis;">{{item.title}}</span>
										</p>
										</router-link>
									</el-carousel-item>
								</el-carousel>
							</div>
							<!-- 如果需要分页器 -->
							<!-- <div class="swiper-pagination"></div> -->
						</div>
					</li>
				</ul>
			</div>
			<div class="gzdt-right">
				<div class="gzdt-right-top">
					<ul>
						<li>
							<div id="gzdt" :class="gzdton?'gzdt-on':''" @click="switchitemsss('1')">工作动态</div>
						</li>
						<li>
							<div id="tzgg" :class="gzdton?'':'gzdt-on'" @click="switchitemsss('2')">通知公告</div>
						</li>
					</ul>
				</div>
				<!-- 工作动态 -->
				<div class="gzdt-right-bottom" v-if="alter=='1'">
					<ul>
						<li v-for="(item,index) in webinfo.newsList" :key="index">
							<span class="gzdt-time">[{{item.time}}]</span>
							<router-link target="_blank" :to="{name:'details',params:{type:'news',id:item.id}}">{{item.title}}</router-link>
						</li>
					</ul>
				</div>
				<!-- 通知公告 -->
				<div class="gzdt-right-bottom" v-if="alter=='2'">
					<ul>
						<li v-for="(item,index) in webinfo.notifyList" :key="index">
							<span class="gzdt-time">[{{item.time}}]</span>
							<router-link target="_blank" :to="{name:'details',params:{type:'notify',id:item.id}}">{{item.title}}</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--在线服务-->
		<div class="w1 container">
			<div class="zjyx">
				<div class="zjyx-top">
					<span>在线服务</span>
					<router-link :to="{name:'morezx'}">查看更多+</router-link>
				</div>
				<div class="zjyx-bottom">
					<div class="ma-box">
						<div class="ma1">
							<span>微信小程序</span><br />
							<img src="../assets/img/ma.png" alt="" />
						</div>
						<div class="ma2">
							<span>微信公众号</span><br />
							<img src="../assets/img/gzh.jpg" alt="" />
						</div>
					</div>
					<div class="anniu-box">
						<button class="e-anniu" @click.stop="Switchitem('1')">网上咨询</button>
						<button class="e-anniu" @click.stop="Switchitem('2')">网上预约</button>
						<button class="e-anniu" @click.stop="Switchitem('3')">网上申办</button>
					</div>
				</div>

				<div class="zjyx-bottom-right">
					<div class="zixun-left">
						<img src="../assets/img/zixun.jpg" alt="" />
						<div class="zixun-down">最新回复</div>
					</div>
					<div class="zixun-right" v-for="(item,index) in ConsultingList">
						<div class="wenti-box">
							<div class="yihuifu">已回复</div>
							<div class="wenti-right">
								<div class="wenti">{{item.content}}</div>
								<div class="jieda">
									{{item.replycontent}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 专题横幅 -->
		<div class="special-box container" v-for="(item,index) in webinfo.specialList" :key="index">
			<a :href="item.url" target="_blank">
				<img :src="hoturl + item.img" alt="" />
			</a>
		</div>
		<!-- 法律法规、办证指南 -->
		<div class="w2 container">
			<div class="mtjj">
				<div class="mtjj-top">
					<span>法律法规</span>
					<router-link :to="{name:'laws',params:{page:'1'}}">查看更多+</router-link>
				</div>
				<div class="mtjj-bottom">
					<ul>
						<li v-for="(item,index) in webinfo.lawstatuteList">
							<span class="zjyx-time">[{{item.time}}]</span>
							<router-link target="_blank" :to="{name:'details',params:{type:'lawstatute',id:item.id}}">{{item.title}}</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="bjtx">
				<div class="mtjj-top">
					<span>办证指南</span>
					<router-link :to="{name:'laws',params:{page:'2'}}">查看更多+</router-link>
				</div>
				<div class="mtjj-bottom">
					<ul>
						<li v-for="(item,index) in webinfo.guideList">
							<span class="zjyx-time">[{{item.time}}]</span>
							<router-link target="_blank" :to="{name:'details',params:{type:'guide',id:item.id}}">{{item.title}}</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--公证人员风采-->
		<div class="yyxtdh1 container">
			<div class="yyxtdh-top">
				<span>公证人员风采</span>
				<router-link :to="{name:'Personnel'}">查看更多+</router-link>
			</div>
			<div id="div1">
				<nav>
					<ul>
						<li v-for="(item, index) in webinfo.teamList" :key="index" class="img_box">
							<div>
								<img :src="hoturl + item.img" mode="aspectFill" height="80%" />
							</div>
							<div class="gz-name">{{item.name}}<br />({{item.duties}})</div>
						</li>
					</ul>
				</nav>
			</div>
		</div>
		<!--申办公证所需材料-->
		<div class="yyxtdh container">
			<div class="yyxtdh-top">
				<span>申办公证所需材料</span>
				<router-link :to="{name:'material',params:{page:'1'}}">查看更多+</router-link>
			</div>
			<div class="yyxtdh-bottom">
				<ul>
					<li class="yyxtdh-left" v-for="(item,index) in webinfo.matterList">
						<router-link :to="{name:'material',params:{page:item.id}}">
							<img :src="hoturl+item.img" />
							<p>{{item.title}}</p>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<!--友情链接-->
		<div class="yqlj container">
			<div class="yyxtdh-top">
				<span>友情链接</span>
				<!-- <a href="#">查看更多+</a> -->
			</div>
			<div class="yqlj-box">
				<a v-for="(item,index) in webinfo.linksList" :key="index" :href="'http://'+item.url" target="_blank">{{item.name}}</a>
			</div>
		</div>

		<!--友情链接-->
		<div class="map container">
			<div class="yyxtdh-top">
				<span>服务地图</span>
			</div>
			<div class="map-box">
				<!-- 				<baidu-map class="bm-view" ak="cIaugraO6p3anIRMOqGufIv1rBUwNVR5"
					:center="{lng: 114.53714, lat: 36.614429}" style="width: 100%;height: 442px;" :zoom="15">
				</baidu-map> -->

				<baidu-map class="map" style="width: 100%; height: 442px" :center="{ lng: webinfo.webSiteConfig.longitude, lat: webinfo.webSiteConfig.latitude }"
					:zoom="15">
					<bm-marker :position="{ lng: webinfo.webSiteConfig.longitude, lat: webinfo.webSiteConfig.latitude }" :dragging="true" @click="infoWindowOpen">
						<bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
							<div class="info">
								<span class="info_name">{{webinfo.webSiteConfig.companyname}}</span>
								<p class="info_phone">联系电话：{{webinfo.webSiteConfig.companytel}}</p>
								<p class="info_add">
									地址：{{webinfo.webSiteConfig.companyaddress}}
								</p>
							</div>
						</bm-info-window>
					</bm-marker>
				</baidu-map>
			</div>
		</div>

		<!-- 锚点 -->
		<p id="back-to-top">
			<a href="#top"><img src="../assets/img/go-top.png" alt="" /></a>
		</p>
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from "../components/headinfo.vue";
	import bottominfo from "../components/bottominfo.vue";
	import float from '../components/float.vue'
	import {
		global
	} from '../api/index.js'
	import {getHomeConsultingList} from '../api/indexapp.js'
	export default {
		name: "home",
		components: {
			headinfo,
			bottominfo,
			float
		},
		metaInfo: {
			title: '河北省邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '河北省邯郸市诚信公证处、邯郸市诚信公证处、诚信公证处'
			}],
		},
		data() {
			return {
				hoturl: '/cxWebApi/profile',
				webinfo:null,
				gzdton: true,
				show: true,
				alter: '1',
				img: require("../assets/img/float.png"),
				ConsultingList:[],
			};
		},
		created() {
			this.getglobal();
		},
		methods: {
			Switchitem(row){
				let obj = JSON.parse(sessionStorage.getItem('webopenId'));
				if(obj==null){
					this.$message.error('请先登陆！');
				}else{
					this.$router.push({name:'serve',params: {page:row}}).catch(err =>{})
				}
			},
			switchitemsss(row) {
				this.alter = row;
				if (row == '1') {
					this.gzdton = true;
				} else {
					this.gzdton = false;
				}
			},
			getglobal() {
				global().then(res => {
					this.webinfo = res.data;
					getHomeConsultingList().then(res=>{
						this.ConsultingList = res.data;
					})
				})
			},
			infoWindowClose() {
				this.show = false;
			},
			infoWindowOpen() {
				this.show = true;
			},
		},
	};
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
	/* @import "../assets/css/swiper-master/package/swiper-bundle.css"; */
	@import "../assets/css/sliderx.css";
	@import "../assets/css/login.css";

	.img_box {
		margin-right: 15px;
	}

	#div1 ul {
		/* width: 200%; */
		height: 100%;
		animation: picmove 20s linear infinite forwards;
	}

	@keyframes picmove {
		from {
			transform: translate(0);
		}

		to {
			transform: translate(-750px);
		}
	}

	#div1 ul:hover {
		animation-play-state: paused;
	}

	.info {
		text-align: center;
		line-height: 26px;
		font-size: 14px !important;
		font-weight: 500 !important;
		font-family: "STKaiti", 华文楷体, "FangSong", 仿宋, "SimSun", 宋体;
	}

	.info_name {
		font-size: 20px !important;
		font-weight: 600;
		color: #e10200;
		font-family: "STKaiti", 华文楷体, "FangSong", 仿宋, "SimSun", 宋体;
	}
</style>
